import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';


import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Icon from '../Icon';

import NavListWithCollapse from './NavListWithCollapse';

//import MiddleSectionOrgs from './NavContentOrgs';
import Header from './NavHeader';

import BottomSection from './BottomSection';

import ShortMenu from "./shortMenu";

const drawer_width = 300;

/*///////////////////////////////////////////////////////////////////////////////////
                                MIDDLE SECTION
///////////////////////////////////////////////////////////////////////////////////*/

const middle_section_styles = theme => ({
  app_changer_class: {
    marginTop: 'auto',
    cursor: 'pointer',
    marginBottom: 0,
  },
  list_item: {
    padding: theme.margins.sm
  },
  zero_margin_right: {
    marginRight: 0,
    minWidth: 36
  },
  overflow: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  }
});

const MiddleSection = React.memo(withStyles(middle_section_styles)(({
  classes,
  app_changer,
  ...props
}) => (
    <Fragment>
      <NavListWithCollapse {...props} />
      {
        Boolean(app_changer && app_changer.length) ?
          (
            <List className={classes.app_changer_class}>
              {
                app_changer.map(({ icon_type, name, link }, index) => (
                  <React.Fragment key={`app-changer-${name}-${index}`}>
                    <Divider />
                    <ListItem classes={{ root: classes.list_item }}>
                      <ListItemIcon className={classes.zero_margin_right}>
                        <Icon size="sm" type={icon_type} />
                      </ListItemIcon>
                      <ListItemText
                        primary={props.menu_open ? name : ""}
                        component={props.link_component}
                        href={link}
                        classes={{
                          primary: classes.overflow
                        }}
                      />
                    </ListItem>
                  </React.Fragment>
                ))
              }
            </List>
          ) : null
      }
    </Fragment>
  )))

/*///////////////////////////////////////////////////////////////////////////////////
                                  MIDDLE HEADER SECTION
///////////////////////////////////////////////////////////////////////////////////*/

const middle_header_section_styles = theme => ({
  root: {
    flex: 1,
    flexDirection: 'column'
  },
  list_item: {
    // padding: theme.margins.sm,
    '&:hover': {
      color: theme.palette.lightGrey,
    },
    paddingLeft: "16px !important"
  },
  selected: {
    // background: "rgba(38, 187, 237, 0.06)"
  },
  list_item_text: {
    color: theme.palette.darkBlack,
    fontWeight: theme.fontWeight.main,
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '&:hover': {
      color: theme.palette.hylyBlue,
    },
    paddingLeft: `0 !important`,
  }
})


const MiddleHeaderSection = React.memo(withStyles(middle_header_section_styles)(({
  classes,
  logout_function,
  header_props,
  pathname,
  small,
  ...props
}) => {

  const check_if_selected = (item, path) => new RegExp(path, "g").test(item);
  const create_path = (path = '/') => Boolean(path) && /^\//.test(path) ? path : Boolean(path) ? '/' + path : '/';


  return (
    <List className={classes.root}>
      {
        Boolean(header_props && header_props.length)
          ? header_props.map(({
            to, // ** where does this item link to **
            path, // ** when to show this item as selected (bold) **
            name,
            disabled,
            link_component,
            ...other
          }, index) => {

            const data_selected = check_if_selected(path, pathname);

            return (
              <ListItem
                key={name}
                selected={data_selected}
                component={link_component || props.link_component}
                to={create_path(to)}
                disabled={disabled}
                onClick={props.menu_open ? null : props.onClose}
                classes={{ root: classes.list_item }}
                {...other}
              >
                <ListItemText
                  primary={name}
                  classes={{
                    primary: `${classes.list_item_text} ${data_selected ? classes.selected : ''}`,
                  }}
                />
              </ListItem>
            );
          }
          ) : null
      }
      <ListItem
        key='signout'
        id="signout"
        onClick={logout_function}
        classes={{ root: classes.list_item }}
      >
        <ListItemText
          primary={'Sign Out'}
          classes={{
            primary: classes.list_item_text,
          }}
        />
      </ListItem>
    </List>
  )
}))



/*///////////////////////////////////////////////////////////////////////////////////
                                  NAV CONTENT
///////////////////////////////////////////////////////////////////////////////////*/

const styles = theme => ({
  root: {
    width: drawer_width,
    background: theme.palette.white,
    flexWrap: 'nowrap',
    flex: 1,
    overflow: 'hidden',
    [theme.breakpoints.up('lg')]: {
      width: '100%',
      maxWidth: drawer_width,
    }
  },
  container: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  container_selected_org: {
    marginBottom: 64,
  },
  container_selected_property: {
    marginBottom: 88,
  },
  container_default: {
    marginBottom: 56
  },
  submenu: {
    marginLeft: 63,
  },
  subMenuItem: {
    backgroundColor: theme.palette.white,
    padding: "10px 20px;"
  },
  selectedSubMenuItem: {
    color: `${theme.palette.hylyBlue} !important;`
  },
  subMenuItemText: {
    paddingLeft: "0 !important",
    color: theme.palette.darkBlack
  },
  submenuPopover: {
    boxShadow: "none !important",
    backgroundColor: theme.palette.white,
    padding: "0 12px",
    minWidth: 180,
    left: "17px !important"
  }
})

const NavContent = ({
  classes: {
    root,
    container,
    container_selected_property,
    container_selected_org,
    container_default,
    submenu,
    submenuPopover
  },
  user: {
    name,
  },
  app_changer,
  header_props,
  logout_function,
  pathname,
  suborg_change_available,
  ...props
}) => {


  const [page, set_page] = React.useState("default");
  const [currentTarget, setCurrentTarget] = React.useState(null);


  const clear_target = () => {
    setCurrentTarget(null)
  }

  function header_changer(e) {
    if (props.menu_open)
      set_page(page === "head" ? "default" : "head");
    else
      setCurrentTarget(e.currentTarget);
  }

  React.useEffect(() => {
    setCurrentTarget(null)
  }, [props.menu_open])

  const container_class = React.useMemo(() => {
    const { selected_property, selected_org } = props;
    return Boolean(selected_property && selected_property.name)
      ? container_selected_property
      : Boolean(selected_org && selected_org.name)
        ? container_selected_org
        : container_default
  }, [props.selected_property])

  return (
    <Grid
      container
      direction="column"
      className={root}
    >
      <Grid
        direction="column"
        container
        wrap="nowrap"
        className={container + ' ' + container_class}
      >
        {
          /default|head/.test(page)
            ?
            <>
              <Header
                name={name}
                onClick={header_changer}
                pressed={page === "head"}
                menu_open={props.menu_open}
                currentTarget={currentTarget}
                swipeable={props.swipeable}
              />
              <ShortMenu open={Boolean(!props.swipeable && !props.menu_open && currentTarget)} classes={submenu} popoverClasses={{ paper: submenuPopover }} anchorEl={currentTarget} handleClose={clear_target}>
                <MiddleHeaderSection logout_function={logout_function} pathname={pathname} header_props={header_props} small />
              </ShortMenu>
            </>
            : null
        }

        {page === "head" && (props.menu_open || props.swipeable) ? <MiddleHeaderSection logout_function={logout_function} pathname={pathname} header_props={header_props} /> : null}
        {page === "default" ? <MiddleSection app_changer={app_changer} pathname={pathname} {...props} /> : null}
        {page !== "head" ? <BottomSection suborg_change_available={Boolean(suborg_change_available)} {...props} /> : null}
      </Grid>

    </Grid>
  );
}

const one_of_props = (props, propName, componentName) => {
  if (!props.to && !props.href) {
    return new Error(`One of props 'to' or 'href' was not specified in '${componentName}'.`);
  }
};

NavContent.propTypes = {

  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    container: PropTypes.string.isRequired
  }),

  user: PropTypes.shape({
    name: PropTypes.string,
    property: PropTypes.string,
    // org: PropTypes.shape({
    // id: PropTypes.string,
    //})
  }),

  orgs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),

  bottom_section: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  banner: PropTypes.node,

  onClose: PropTypes.func.isRequired,

  logout_function: PropTypes.func,

  app_changer: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon_type: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
  })),

  header_props: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    to: one_of_props,
    href: one_of_props,
    disabled: PropTypes.bool,
    link_component: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
  })),

  suborg_change_available: PropTypes.bool,

  pathname: PropTypes.string.isRequired,

  onSelect: PropTypes.func

}

NavContent.defaultProps = {

  link_component: 'div',

  is_online: true,

  menu_open: false,

  suborg_change_available: false,

  pathname: '/',

}

export default withStyles(styles)(NavContent);
